/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ billable: NonNullable<unknown> }} Partner_Billing_Board_Alltime_Billable_OnlyInputs */



/**
* | output |
* | --- |
* | "{billable} billable now, across all closed months. Nothing is accruing in the open month." |
*
* @param {Partner_Billing_Board_Alltime_Billable_OnlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_alltime_billable_only = /** @type {((inputs: Partner_Billing_Board_Alltime_Billable_OnlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Alltime_Billable_OnlyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.billable} jetzt fakturierbar, über alle abgeschlossenen Monate. Im offenen Monat läuft nichts auf.`)
	return /** @type {LocalizedString} */ (`${i?.billable} billable now, across all closed months. Nothing is accruing in the open month.`)
});